<template>
    <section>
        <b-btn type="primary" :class="{disabled: disabled}" @click="openModal()">{{$t('message.add_unit')}}</b-btn>
        <b-modal v-model="open" :title="$t('message.add_unit')" ref="modal" id="modal-unit">
            <vue-form-generator ref="createUnit" :schema="schema" :model="model" :options="formOptions" @validated="onValidated"></vue-form-generator>
            <template #footer>
                <b-btn @click="open=false">{{$t('message.cancel')}}</b-btn>
                <b-btn @click="validate" type="primary">{{$t('message.create')}}</b-btn>
            </template>
        </b-modal>
    </section>
</template>

<script>
    import VueFormGenerator from 'vue-form-generator'
    import storage, {BUILDING_REQUEST, UNIT_REQUEST} from '../../../_store'
    import mixins from '../../../modules/mixins'
    import eventBus from '../../../modules/eventBus'

    export default {
        name: 'create-unit',
        mixins: [mixins],
        props: {
            unit: {
                type: String
            }
        },
        data () {
            return {
                open: false,
                isValid: false,
                disabled: false,
                model: {
                    building: null,
                    name: null,
                    floor: '',
                    tenants: 1,
                    pricePerLiterCold: 'true-0.1',
                    pricePerLiterHot: 'true-0.1',
                    pricePerPower: 'true-4.5',
                    pricePerUnit: 'true-1'
                },
                schema: {
                    fields: [{
                        type: 'select',
                        label: this.$t('message.building'),
                        i18n: {
                            label: 'message.building'
                        },
                        model: 'building',
                        required: true,
                        values: []
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.name'),
                        i18n: {
                            label: 'message.name',
                            placeholder: 'message.unit_name_placeholder'
                        },
                        model: 'name',
                        placeholder: this.$t('message.unit_name_placeholder'),
                        featured: true,
                        required: true,
                        validator: VueFormGenerator.validators.string
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.$t('message.floor'),
                        i18n: {
                            label: 'message.floor'
                        },
                        model: 'floor',
                        required: false
                    }, {
                        type: 'input',
                        inputType: 'integer',
                        i18n: {
                            label: 'message.tenants'
                        },
                        model: 'tenants',
                        required: false
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_cold_water',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                        },
                        model: 'pricePerLiterCold',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_hot_water',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                        },
                        model: 'pricePerLiterHot',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_power',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.power')
                        },
                        model: 'pricePerPower',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }, {
                        type: 'checkboxText',
                        i18n: {
                            label: 'message.price_estimate_heat',
                            checkboxLabel: 'message.from_parent_object',
                            unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.heat_units')
                        },
                        model: 'pricePerUnit',
                        pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                        validator: [VueFormGenerator.validators.regexp]
                    }]
                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChanged: true
                }
            }
        },
        methods: {
            onValidated  (isValid) {
                this.isValid = isValid
            },
            validate () {
                this.$refs.createUnit.validate()
                if (this.isValid) {
                    storage.dispatch(UNIT_REQUEST, this.model)
                        .then(response => {
                            this.open = false
                            eventBus.emit('change', {force: true, source: 'create-unit'})
                        }) // TODO catch ERROR
                    this.open = false
                }
            },
            openModal () {
                if (this.disabled) {
                    return
                }
                this.resetModel()
                this.open = true
            },
            resetModel () {
                this.model = {
                    building: null,
                    name: null,
                    floor: '',
                    tenants: 1,
                    pricePerLiterCold: 'true-0.1',
                    pricePerLiterHot: 'true-0.1',
                    pricePerPower: 'true-4.5',
                    pricePerUnit: 'true-1'
                }
            },
            loadData () {
                storage.dispatch(BUILDING_REQUEST).then((response) => {
                    if (response.data.data.length === 0) {
                        this.disabled = true
                        return
                    } else {
                        this.disabled = false
                    }
                    this.schema.fields[0].values = response.data.data
                    this.model.building = response.data.data[0].id
                })
            }
        },
        created () {
            this.loadData()
            this.stopChangeListener = eventBus.on('change', request => {
                if (request && request.force) {
                    this.loadData()
                }
            })
        },
        beforeUnmount () {
            this.stopChangeListener()
        }
    }
</script>

<style scoped>

</style>
